//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { map , filter } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const examsInitial = [];




export const howToVideos = (state = examsInitial, action) => {
    switch (action.type) {
        case ActionTypes.howToVideos.createHowToVideosSuccess:
            return [...state, action.payload];
        case ActionTypes.howToVideos.listHowToVideosSuccess:
            return action.payload;
        case ActionTypes.howToVideos.updateHowToVideosSuccess:
            return map(state,dt=>{
                if(dt.id===action.payload.id){
                    return action.payload;
                }
                return dt;
            })
        case ActionTypes.howToVideos.deleteHowToVideosSuccess:
            return filter(state,dt=>dt.id!==action.payload)
        default:
            return state;
    }
};
